// extracted by mini-css-extract-plugin
export default {"imageGallery":"imageGallery_imageGallery__aelpg"};